/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { OneDWaterLevelPredefined } from "./OneDWaterLevelPredefined";
import {
  OneDWaterLevelPredefinedFromJSON,
  OneDWaterLevelPredefinedFromJSONTyped,
  OneDWaterLevelPredefinedToJSON,
  OneDWaterLevelPredefinedToJSONTyped,
} from "./OneDWaterLevelPredefined";

/**
 *
 * @export
 * @interface PaginatedOneDWaterLevelPredefinedList
 */
export interface PaginatedOneDWaterLevelPredefinedList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<OneDWaterLevelPredefined>;
}

/**
 * Check if a given object implements the PaginatedOneDWaterLevelPredefinedList interface.
 */
export function instanceOfPaginatedOneDWaterLevelPredefinedList(
  value: object
): value is PaginatedOneDWaterLevelPredefinedList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedOneDWaterLevelPredefinedListFromJSON(
  json: any
): PaginatedOneDWaterLevelPredefinedList {
  return PaginatedOneDWaterLevelPredefinedListFromJSONTyped(json, false);
}

export function PaginatedOneDWaterLevelPredefinedListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedOneDWaterLevelPredefinedList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(OneDWaterLevelPredefinedFromJSON),
  };
}

export function PaginatedOneDWaterLevelPredefinedListToJSON(
  json: any
): PaginatedOneDWaterLevelPredefinedList {
  return PaginatedOneDWaterLevelPredefinedListToJSONTyped(json, false);
}

export function PaginatedOneDWaterLevelPredefinedListToJSONTyped(
  value?: PaginatedOneDWaterLevelPredefinedList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(OneDWaterLevelPredefinedToJSON),
  };
}
